import { sortBy, map, filter } from 'lodash';
import DateUtils from '../../utils/DateUtils';
import FrequencyUtils from '../../utils/FrequencyUtils';
import StringConstant from '../../constants/StringConstants';
import moment from 'moment';
import config from '../../config';
import AccountStore from '../../stores/AccountsStore';
import MoveMoneyStore from '../../stores/MoveMoneyStore';

class ManagePaymentBL {
  sortPayment(paymentList, sort, sortAscending) {
    let showIcon = true;
    if (paymentList === null) {
      return null;
    }
    let sortedData = null;
    switch (sort) {
      case 'fromAccountName':
        sortedData = sortBy(paymentList, [
          'fromAccountName',
          'fromAccountId',
          'toAccountName',
        ]);
        break;
      default:
        sortedData = sortBy(paymentList, [sort]);
    }
    if (sortAscending === 'desc') {
      sortedData.reverse();
    }
    map(sortedData, (tranasaction) => {
      delete tranasaction.showIcon;
      if (tranasaction.category === 'DD' && showIcon) {
        tranasaction.showIcon = true; // Or replace the whole obj
        showIcon = false;
      }
    });
    return sortedData;
  }

  filterPaymentList(paymentList, selectedKey) {
    let filteredList = [];
    switch (selectedKey) {
      case 1:
        filteredList = paymentList;
        break;
      case 2:
        filteredList = filter(paymentList, (payment) => {
          return payment.category === 'DD';
        });
        break;
      case 3:
        filteredList = filter(paymentList, (payment) => {
          return payment.category === 'SO' && payment.soType === 'SCHEDULE';
        });
        break;
      case 4:
        filteredList = filter(paymentList, (payment) => {
          return payment.category === 'SO' && payment.soType === 'SINGLE';
        });
        break;
    }
    return filteredList;
  }

  getDate(date) {
    let formatedDate = DateUtils.getMomentFromDateString(date);
    formatedDate = moment(formatedDate).format(config.dateFormatTimeline);
    return formatedDate;
  }

  getRepeatData(activeData) {
    const repeatData = {};
    let frequency = this.parseFrequency(activeData.frequency);
    if (!frequency) {
      frequency = StringConstant.unAvailable;
    }
    repeatData.frequency = frequency;
    const nextDue = DateUtils.getMomentFromDateString(activeData.when);
    repeatData.nextDue = moment(nextDue).format(config.dateFormatTimeline);
    return repeatData;
  }

  parseFrequency(frequency) {
    const key = Object.keys(frequency);
    const frequencyObject = frequency[key];
    if (frequencyObject.hasOwnProperty(StringConstant.interval)) {
      if (Object.keys(frequencyObject).length !== 1) {
        return null;
      } else {
        const value = frequencyObject.interval;
        const parsedFrequency = `${value} ${key[0]}`;
        return FrequencyUtils.getFrequencyValue(parsedFrequency);
      }
    } else {
      return null;
    }
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  validateReferenceKey(fieldData) {
    if (
      fieldData.hasOwnProperty('reference') &&
      fieldData.reference.trim().length === 0
    ) {
      delete fieldData.reference;
      return fieldData;
    } else {
      return fieldData;
    }
  }

  createEditSoRequestPacket(editedData) {
    let editPaymentRequest = {};
    editPaymentRequest.display_name = editedData.toAccountName;
    editPaymentRequest.sort_code = editedData.sortCode;
    editPaymentRequest.reference = editedData.reference;
    editPaymentRequest = this.validateReferenceKey(editPaymentRequest);
    editPaymentRequest.account_number = editedData.accountNumber;
    const amount = {
      value: editedData.amount,
      currency: editedData.currency,
    };
    if (editedData.soType === 'SINGLE') {
      editPaymentRequest.single = {
        when: DateUtils.getAPIDateString(editedData.when),
        amount,
      };
    } else {
      const schedule = {
        start_condition: {},
        recurrence: {
          frequency: {},
        },
      };
      editPaymentRequest.schedule = schedule;
      editPaymentRequest.schedule.start_condition.when =
        DateUtils.getAPIDateString(editedData.when);
      editPaymentRequest.schedule.recurrence.frequency =
        editedData.scheduleData.recurrence.frequency;
      if (editedData.scheduleData.hasOwnProperty('end_condition')) {
        editPaymentRequest.schedule.end_condition =
          editedData.scheduleData.end_condition;
      }
      editPaymentRequest.schedule.recurrence.amount = amount;
    }
    return editPaymentRequest;
  }

  getToAccount({ accountNumber, sortCode, toAccountId }) {
    const account =
      MoveMoneyStore.getPayeeByAccountNumberSortCode(accountNumber, sortCode) ||
      AccountStore.getAccountByAccountNumberSortCode(accountNumber, sortCode) ||
      AccountStore.getAccountDetail(toAccountId);
    if (account) {
      return {
        toAccount: account.id,
      };
    }
  }
}

export default new ManagePaymentBL();
